var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { fetchAccountTransactions } from '@popup/steem/actions/transaction.actions';
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { BackToTopButton } from 'src/common-ui/back-to-top-button/back-to-top-button.component';
import { SVGIcons } from 'src/common-ui/icons.enum';
import RotatingLogoComponent from 'src/common-ui/rotating-logo/rotating-logo.component';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
import getMessage from 'src/background/utils/i18n.utils';
import FlatList from 'flatlist-react';
import { WalletHistoryItemComponent } from './wallet-history-item/wallet-history-item.component';
// LIMITI DIFFERENTI PER CHAIN
// Hive: limit=1000 → 1000 record
// Steem/Blurt/TIME: limit=999 → 1000 record
const getLimitForChain = (currency) => {
    return currency === 'HIVE' ? 1000 : 999;
};
const formatTsIt = (ts) => {
    try {
        return new Date(ts).toLocaleDateString('it-IT', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        });
    }
    catch (_a) {
        return String(ts !== null && ts !== void 0 ? ts : '');
    }
};
const isVirtualOp = (tx) => {
    const isZeroTx = tx.txId === '0' ||
        tx.txId === '-' ||
        tx.txId === '0000000000000000000000000000000000000000';
    const isMaxTrxInBlock = tx.trx_in_block === 4294967295;
    const hasVirtualOp = !!tx.virtual_op &&
        (typeof tx.virtual_op === 'number' ? tx.virtual_op > 0 : true);
    const containsVirtual = typeof tx.txId === 'string' && tx.txId.toLowerCase().includes('virtual');
    return isZeroTx || isMaxTrxInBlock || hasVirtualOp || containsVirtual;
};
const txToText = (tx) => {
    var _a, _b, _c, _d, _e;
    const virtual = isVirtualOp(tx);
    const virtualOpIndex = (_a = tx.virtual_op) !== null && _a !== void 0 ? _a : tx.index;
    const lines = [];
    lines.push(`Op.: ${tx.index}`);
    lines.push(`Date: ${formatTsIt(tx.timestamp)}`);
    lines.push(`Type: ${tx.type}`);
    if (virtual) {
        lines.push(`Trx Id: Virtual Op #${virtualOpIndex}`);
    }
    else {
        lines.push(`Trx Id: ${(_b = tx.txId) !== null && _b !== void 0 ? _b : ''}`);
    }
    if (tx.blockNumber != null) {
        if (virtual) {
            lines.push(`Block/Virtual Op: ${tx.blockNumber}/${virtualOpIndex}`);
        }
        else if (tx.trx_in_block != null) {
            lines.push(`Block/Tx Num: ${tx.blockNumber}/${tx.trx_in_block}`);
        }
    }
    lines.push(`Block: ${(_c = tx.blockNumber) !== null && _c !== void 0 ? _c : ''}`);
    lines.push(`Num Trx: ${(_d = tx.trx_in_block) !== null && _d !== void 0 ? _d : ''}`);
    lines.push(`Op Trx: ${(_e = tx.op_in_trx) !== null && _e !== void 0 ? _e : ''}`);
    if (tx.details && typeof tx.details === 'object') {
        for (const [key, value] of Object.entries(tx.details)) {
            if (value === undefined)
                continue;
            lines.push(`${key}: ${typeof value === 'object' ? JSON.stringify(value, null, 2) : String(value)}`);
        }
    }
    return lines.join('\n');
};
const downloadTextFile = (content, filename) => {
    const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    setTimeout(() => URL.revokeObjectURL(url), 2000);
};
const WalletHistory = ({ transactions, activeAccountName, fetchAccountTransactions, setTitleContainerProperties, currency, }) => {
    var _a, _b;
    const [isFilterOpened, setIsFilterPanelOpened] = useState(false);
    const [availableTypes, setAvailableTypes] = useState([]);
    const [selectedTypes, setSelectedTypes] = useState([]);
    const [displayedTransactions, setDisplayedTransactions] = useState([]);
    const [displayScrollToTop, setDisplayedScrollToTop] = useState(false);
    const [loading, setLoading] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    // Flag per distinguere "Deselect All" (bottone) da toggle singolo
    const [userExplicitlyDeselected, setUserExplicitlyDeselected] = useState(false);
    const requestedStartRef = useRef(-1);
    const walletItemList = useRef(null);
    const toggleFilter = () => setIsFilterPanelOpened(old => !old);
    useEffect(() => {
        init();
    }, [currency, activeAccountName]);
    const finalizeDisplayedList = (list, shouldClear = false) => {
        var _a, _b, _c, _d;
        console.log('[FINALIZE] clear=' + shouldClear + ', list.length=' + list.length +
            ', first=' + ((_b = (_a = list[0]) === null || _a === void 0 ? void 0 : _a.index) !== null && _b !== void 0 ? _b : 'N/A') + ', last=' + ((_d = (_c = list[list.length - 1]) === null || _c === void 0 ? void 0 : _c.index) !== null && _d !== void 0 ? _d : 'N/A'));
        setDisplayedTransactions(shouldClear ? list : [...displayedTransactions, ...list]);
        setLoading(false);
    };
    const init = () => __awaiter(void 0, void 0, void 0, function* () {
        console.log('[INIT] currency=' + currency + ', account=' + activeAccountName);
        setTitleContainerProperties({
            title: 'popup_html_wallet_history',
            isBackButtonEnabled: true,
            rightAction: {
                icon: SVGIcons.WALLET_HISTORY_FILTER_BUTTON,
                callback: toggleFilter,
                className: 'wallet-filter-button',
            },
        });
        setLoading(true);
        setSelectedTypes([]);
        setUserExplicitlyDeselected(false);
        setDisplayedTransactions([]);
        requestedStartRef.current = -1;
        const limit = getLimitForChain(currency);
        console.log('[INIT] calling fetchAccountTransactions start=-1, limit=' + limit);
        yield fetchAccountTransactions(activeAccountName, currency, -1, limit, true);
    });
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        console.log('[USE EFFECT transactions] triggered', 'list.length=' + ((_b = (_a = transactions.list) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0), 'totalCount=' + transactions.totalCount, 'requestedStartRef=' + requestedStartRef.current);
        if (!transactions.list || transactions.list.length === 0) {
            console.log('[USE EFFECT] list empty, skipping');
            if (transactions.totalCount !== undefined)
                setTotalCount(transactions.totalCount);
            return;
        }
        let list = [...transactions.list];
        // STEP 1: totalCount
        if (requestedStartRef.current === -1) {
            const realTotal = list[0].index + 1;
            console.log('[USE EFFECT] start=-1 → totalCount = list[0].index(' + list[0].index + ') + 1 = ' + realTotal);
            setTotalCount(realTotal);
        }
        else if (transactions.totalCount) {
            const maxSeen = Math.max(list[0].index + 1, transactions.totalCount);
            console.log('[USE EFFECT] start>0 → totalCount = max(' + (list[0].index + 1) + ', ' + transactions.totalCount + ') = ' + maxSeen);
            setTotalCount(prev => Math.max(prev, maxSeen));
        }
        // STEP 2: TRIM (dovrebbe non servire più con il limit corretto)
        if (list.length > 1000) {
            console.log('[USE EFFECT] WARNING: list.length=' + list.length + ' > 1000, trimming...');
            if (requestedStartRef.current === -1) {
                list = list.slice(0, 1000);
                console.log('[USE EFFECT] TRIMMED (start=-1): slice(0,1000) → length=' + list.length);
            }
            else {
                const maxOp = requestedStartRef.current;
                const minOp = maxOp - 999;
                list = list.filter(t => t.index >= minOp && t.index <= maxOp);
                console.log('[USE EFFECT] TRIMMED (start=' + requestedStartRef.current + '): filter [' + minOp + '-' + maxOp + '] → length=' + list.length);
            }
        }
        else {
            console.log('[USE EFFECT] No trim needed (length=' + list.length + ' <= 1000)');
        }
        console.log('[USE EFFECT] AFTER TRIM: length=' + list.length +
            ', first.index=' + ((_c = list[0]) === null || _c === void 0 ? void 0 : _c.index) +
            ', last.index=' + ((_d = list[list.length - 1]) === null || _d === void 0 ? void 0 : _d.index));
        // STEP 3: tipi e filtro
        const types = [...new Set(list.map((t) => t.type))];
        console.log('[USE EFFECT] types found: ' + types.length + ' → ' + types.join(', '));
        setAvailableTypes(types);
        let currentSelected;
        if (selectedTypes.length === 0 && !userExplicitlyDeselected) {
            // PRIMO CARICO o cambio account: seleziona tutto
            console.log('[USE EFFECT] First load or account change → select ALL types');
            setSelectedTypes(types);
            currentSelected = types;
        }
        else if (userExplicitlyDeselected && selectedTypes.length === 0) {
            // L'utente ha cliccato "Deselect All": mantieni vuoto
            // MA aggiungi comunque i nuovi tipi come selezionati
            // (sono nuovi, l'utente non ha ancora avuto modo di sceglierli)
            const newTypes = types.filter(t => !availableTypes.includes(t));
            if (newTypes.length > 0) {
                console.log('[USE EFFECT] New types found after Deselect All, auto-selecting: ' + newTypes.join(', '));
                setSelectedTypes(newTypes);
                currentSelected = newTypes;
            }
            else {
                console.log('[USE EFFECT] Deselect All active, no new types, keeping empty');
                currentSelected = [];
            }
        }
        else {
            // L'utente ha una selezione parziale o completa
            // Mantieni la selezione ESISTENTE e AGGIUNGI i nuovi tipi come selezionati
            const knownTypes = availableTypes;
            const newTypes = types.filter(t => !knownTypes.includes(t));
            // Rimuovi tipi che non esistono più nel nuovo batch
            const validExisting = selectedTypes.filter(t => types.includes(t));
            if (newTypes.length > 0) {
                console.log('[USE EFFECT] New types found, auto-adding as selected: ' + newTypes.join(', '));
                const updated = [...validExisting, ...newTypes];
                setSelectedTypes(updated);
                currentSelected = updated;
            }
            else if (validExisting.length !== selectedTypes.length) {
                console.log('[USE EFFECT] Some types removed (not in new batch)');
                setSelectedTypes(validExisting);
                currentSelected = validExisting;
            }
            else {
                currentSelected = selectedTypes;
            }
        }
        const filtered = list.filter((t) => currentSelected.includes(t.type));
        console.log('[USE EFFECT] FILTERED: ' + filtered.length + '/' + list.length +
            ', first=' + ((_f = (_e = filtered[0]) === null || _e === void 0 ? void 0 : _e.index) !== null && _f !== void 0 ? _f : 'N/A') + ', last=' + ((_h = (_g = filtered[filtered.length - 1]) === null || _g === void 0 ? void 0 : _g.index) !== null && _h !== void 0 ? _h : 'N/A'));
        finalizeDisplayedList(filtered, true);
    }, [transactions]);
    const applyFilters = () => {
        var _a;
        if (!((_a = transactions.list) === null || _a === void 0 ? void 0 : _a.length) || selectedTypes.length === 0)
            return;
        const filtered = transactions.list.filter((t) => selectedTypes.includes(t.type));
        finalizeDisplayedList(filtered, true);
    };
    // Toggle singolo tipo: NON tocca il flag userExplicitlyDeselected
    const toggleTypeSelection = (type) => {
        setSelectedTypes(prev => prev.includes(type) ? prev.filter(t => t !== type) : [...prev, type]);
    };
    const selectAllTypes = () => {
        setSelectedTypes([...availableTypes]);
        setUserExplicitlyDeselected(false);
    };
    const deselectAllTypes = () => {
        setSelectedTypes([]);
        setUserExplicitlyDeselected(true);
    };
    const resetFilters = () => {
        setSelectedTypes([...availableTypes]);
        setUserExplicitlyDeselected(false);
    };
    const handleApplyFilter = () => {
        applyFilters();
        setIsFilterPanelOpened(false);
    };
    // isAtEnd
    const isAtEnd = displayedTransactions.length > 0
        ? displayedTransactions[displayedTransactions.length - 1].index === 0
        : false;
    // ===================== BOTTOM =====================
    const goToBottom = () => {
        console.log('========== BOTTOM CLICKED ==========');
        if (!displayedTransactions.length || totalCount === 0)
            return;
        const lastOpNumber = displayedTransactions[displayedTransactions.length - 1].index;
        console.log('[BOTTOM] lastOpNumber=' + lastOpNumber + ', isAtEnd=' + isAtEnd);
        if (lastOpNumber === 0) {
            console.log('[BOTTOM] already at bottom (op=0), just scrolling');
            setTimeout(() => {
                var _a;
                (_a = walletItemList.current) === null || _a === void 0 ? void 0 : _a.scrollTo({ top: walletItemList.current.scrollHeight, behavior: 'smooth' });
            }, 100);
            return;
        }
        console.log('[BOTTOM] Loading ops 0-999');
        requestedStartRef.current = 999;
        setLoading(true);
        const limit = getLimitForChain(currency);
        console.log('[BOTTOM] Calling fetchAccountTransactions start=999, limit=' + limit);
        fetchAccountTransactions(activeAccountName, currency, 999, limit, true);
        setTimeout(() => {
            var _a;
            (_a = walletItemList.current) === null || _a === void 0 ? void 0 : _a.scrollTo({ top: walletItemList.current.scrollHeight, behavior: 'smooth' });
        }, 600);
    };
    // ===================== TOP =====================
    const goToTop = () => {
        console.log('========== TOP CLICKED ==========');
        if (!displayedTransactions.length)
            return;
        const firstOpNumber = displayedTransactions[0].index;
        if (firstOpNumber < totalCount - 1) {
            console.log('[TOP] Reloading with start=-1');
            requestedStartRef.current = -1;
            setLoading(true);
            const limit = getLimitForChain(currency);
            fetchAccountTransactions(activeAccountName, currency, -1, limit, true);
        }
        setTimeout(() => {
            if (walletItemList.current)
                walletItemList.current.scrollTop = 0;
        }, 400);
    };
    // ===================== UP 1000 =====================
    const jumpUp1000 = () => {
        console.log('========== UP 1000 CLICKED ==========');
        if (!displayedTransactions.length)
            return;
        const firstOpNumber = displayedTransactions[0].index;
        const target = firstOpNumber + 1000;
        if (target >= totalCount) {
            console.log('[UP] At maximum, just scrolling');
            setTimeout(() => {
                if (walletItemList.current)
                    walletItemList.current.scrollTop = 0;
            }, 100);
            return;
        }
        console.log('[UP] Loading start=' + target);
        requestedStartRef.current = target;
        setLoading(true);
        const limit = getLimitForChain(currency);
        fetchAccountTransactions(activeAccountName, currency, target, limit, true);
        setTimeout(() => {
            if (walletItemList.current)
                walletItemList.current.scrollTop = 0;
        }, 400);
    };
    // ===================== DOWN 1000 =====================
    const jumpDown1000 = () => {
        console.log('========== DOWN 1000 CLICKED ==========');
        if (!displayedTransactions.length || isAtEnd)
            return;
        const lastOpNumber = displayedTransactions[displayedTransactions.length - 1].index;
        const target = Math.max(0, lastOpNumber - 1000);
        const start = target + 999;
        console.log('[DOWN] Loading start=' + start);
        requestedStartRef.current = start;
        setLoading(true);
        const limit = getLimitForChain(currency);
        fetchAccountTransactions(activeAccountName, currency, start, limit, true);
    };
    const handleScroll = (e) => {
        setDisplayedScrollToTop(e.currentTarget.scrollTop !== 0);
    };
    const exportAllDisplayed = () => {
        var _a, _b;
        if (!displayedTransactions.length)
            return;
        const header = `Wallet history — ${activeAccountName} — ${currency}\n` +
            `Total visible: ${displayedTransactions.length}\n` +
            `Range: ${(_a = displayedTransactions[0]) === null || _a === void 0 ? void 0 : _a.index} - ${(_b = displayedTransactions[displayedTransactions.length - 1]) === null || _b === void 0 ? void 0 : _b.index}\n` +
            `${'='.repeat(40)}\n\n`;
        const body = displayedTransactions
            .map((tx) => txToText(tx))
            .join(`\n\n${'-'.repeat(40)}\n\n`);
        downloadTextFile(header + body + '\n', `wallet-history_${activeAccountName}_${currency}_${Date.now()}.txt`);
    };
    const exportOneTransaction = (tx) => {
        var _a;
        if (!tx)
            return;
        downloadTextFile(txToText(tx) + '\n', `wallet-op_${activeAccountName}_${(_a = tx.index) !== null && _a !== void 0 ? _a : 'x'}_${Date.now()}.txt`);
    };
    const navBtnStyle = (disabled) => ({
        padding: '6px 8px',
        fontSize: '11px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        backgroundColor: disabled ? '#ccc' : '#6d4aff',
        color: '#fff',
        border: 'none',
        borderRadius: '4px',
        flex: 1,
        minHeight: '34px'
    });
    const firstVisibleOp = (_a = displayedTransactions[0]) === null || _a === void 0 ? void 0 : _a.index;
    const lastVisibleOp = (_b = displayedTransactions[displayedTransactions.length - 1]) === null || _b === void 0 ? void 0 : _b.index;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { padding: '8px', backgroundColor: '#f9f9f9', borderBottom: '1px solid #ddd', flexShrink: 0 } },
            React.createElement("div", { style: { textAlign: 'center', fontSize: '13px', color: '#444', marginBottom: '4px' } },
                "User: ",
                activeAccountName,
                " \u2014 Currency: ",
                currency),
            React.createElement("div", { style: { textAlign: 'center', fontSize: '12px', color: '#666', marginBottom: '6px' } },
                "Total Operations: ",
                totalCount,
                firstVisibleOp !== undefined && lastVisibleOp !== undefined && (React.createElement("span", { style: { marginLeft: '4px', color: '#888', fontSize: '11px' } },
                    "(",
                    firstVisibleOp,
                    "-",
                    lastVisibleOp,
                    ")"))),
            React.createElement("div", { style: { display: 'flex', gap: '4px' } },
                React.createElement("button", { onClick: goToTop, disabled: loading, style: navBtnStyle(loading) }, "\u2B06 Top"),
                React.createElement("button", { onClick: jumpUp1000, disabled: loading, style: navBtnStyle(loading) }, "\u25B2 Up 1000"),
                React.createElement("button", { onClick: jumpDown1000, disabled: loading || isAtEnd, style: navBtnStyle(loading || isAtEnd) }, "Down 1000 \u25BC"),
                React.createElement("button", { onClick: goToBottom, disabled: loading || isAtEnd, style: navBtnStyle(loading || isAtEnd) }, "Bottom \u2B07"),
                React.createElement("button", { onClick: exportAllDisplayed, disabled: loading || displayedTransactions.length === 0, style: navBtnStyle(loading || displayedTransactions.length === 0), title: "Save displayed list as .txt" }, "\uD83D\uDCC4 TXT"))),
        React.createElement("div", { className: "wallet-history-page", style: { flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', borderRadius: '0' } },
            React.createElement("div", { ref: walletItemList, className: "wallet-item-list", onScroll: handleScroll, style: { flex: 1, overflowY: 'auto', padding: '4px 0', borderRadius: '0', border: 'none' } },
                React.createElement(FlatList, { list: displayedTransactions, renderItem: (tx) => (React.createElement(WalletHistoryItemComponent, { transaction: tx, onExportTxt: () => exportOneTransaction(tx) })), renderWhenEmpty: () => loading ? (React.createElement("div", { style: { padding: '20px', textAlign: 'center' } },
                        React.createElement(RotatingLogoComponent, null))) : (React.createElement("div", { style: { padding: '20px', textAlign: 'center', color: '#666' } },
                        React.createElement(SVGIcon, { icon: SVGIcons.MESSAGE_ERROR }),
                        React.createElement("div", { style: { marginTop: '8px' } }, getMessage('popup_html_transaction_list_is_empty')))) }),
                displayedTransactions.length > 0 && !loading && (React.createElement("div", { style: { padding: '8px', textAlign: 'center', fontSize: '13px', color: isAtEnd ? '#666' : '#999' } }, isAtEnd ? '— End of operation history —' : 'End of loaded operations — use Down 1000')),
                loading && displayedTransactions.length === 0 && (React.createElement("div", { style: { padding: '20px', textAlign: 'center' } },
                    React.createElement(RotatingLogoComponent, null)))),
            displayScrollToTop && React.createElement(BackToTopButton, { element: walletItemList })),
        isFilterOpened && (React.createElement("div", { style: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '10px' }, onClick: () => setIsFilterPanelOpened(false) },
            React.createElement("div", { style: { background: '#fff', borderRadius: '8px', width: '95%', maxWidth: '480px', maxHeight: '85vh', overflow: 'auto', padding: '12px' }, onClick: e => e.stopPropagation() },
                React.createElement("h3", { style: { margin: '0 0 12px 0', fontSize: '16px' } }, "Filter by Operation Type"),
                React.createElement("div", { style: { display: 'flex', gap: '6px', marginBottom: '10px' } },
                    React.createElement("button", { onClick: selectAllTypes, style: { flex: 1, padding: '8px', fontSize: '13px', background: '#f0f0f0', border: '1px solid #ddd', borderRadius: '4px' } }, "Select All"),
                    React.createElement("button", { onClick: deselectAllTypes, style: { flex: 1, padding: '8px', fontSize: '13px', background: '#f0f0f0', border: '1px solid #ddd', borderRadius: '4px' } }, "Deselect All"),
                    React.createElement("button", { onClick: resetFilters, style: { flex: 1, padding: '8px', fontSize: '13px', background: '#f0f0f0', border: '1px solid #ddd', borderRadius: '4px' } }, "Reset")),
                React.createElement("div", { style: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(130px, 1fr))', gap: '6px', marginBottom: '12px' } }, availableTypes.map(type => (React.createElement("label", { key: type, style: {
                        display: 'flex', alignItems: 'center', gap: '6px', padding: '6px 8px',
                        background: selectedTypes.includes(type) ? '#e3f2fd' : '#fafafa',
                        border: '1px solid #ddd', borderRadius: '4px', cursor: 'pointer', fontSize: '12.5px'
                    } },
                    React.createElement("input", { type: "checkbox", checked: selectedTypes.includes(type), onChange: () => toggleTypeSelection(type) }),
                    React.createElement("span", null, type))))),
                React.createElement("div", { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px solid #eee', paddingTop: '10px' } },
                    React.createElement("div", { style: { fontSize: '13px', color: '#666' } },
                        selectedTypes.length,
                        " / ",
                        availableTypes.length),
                    React.createElement("div", { style: { display: 'flex', gap: '8px' } },
                        React.createElement("button", { onClick: () => setIsFilterPanelOpened(false), style: { padding: '8px 12px', background: '#f0f0f0', border: '1px solid #ddd', borderRadius: '4px' } }, "Cancel"),
                        React.createElement("button", { onClick: handleApplyFilter, style: { padding: '8px 12px', background: '#6d4aff', color: '#fff', border: 'none', borderRadius: '4px' } }, "Apply"))))))));
};
const mapStateToProps = (state) => ({
    transactions: state.steem.transactions,
    activeAccountName: state.steem.activeAccount.name,
    currency: state.navigation.params.tokenSymbol,
});
const connector = connect(mapStateToProps, { fetchAccountTransactions, setTitleContainerProperties });
export const WalletHistoryComponent = connector(WalletHistory);
